import React from 'react'

const Users = () => {
  return (
    <div>
        <div className="d-flex justify-content-between ps-2">
            <h4 className='text-center my-2'>LISTE DES UTILISATEURS</h4>
        </div>
    </div>
  )
}

export default Users